import React, { Component } from "react";
import {
  Card,
  Row,
  Col,
  Form,
  Input,
  Spin,
  Modal as modal,
  Space as space,
  Button as button,
  Menu,
  Modal,
  Typography,
} from "antd";
import PrimaryButton from "../CommonComponent/Buttons/PrimayButton";
import Membershipinfo from "./membershipInfo";
import ClaimsSearchDashboard from "../ClaimsSearch/ClaimsSearchDashboard";
import CliamsHistory from "./cliamsHistory";
import "./searchMember.css";
import NewTab from "../AuthUsers/NewTab";
import Config from "../../config";
import PCPHistory from "../PCP_History/PCPHistory";
import Attestation from "../Attestation/Attestation";
import CreateTicket from "./../TicketManagement/CreateTicket/CreateTicket";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import PrintEligibility from "./PrintEligibility";
import axios from "axios";
import HRAHistory from "../HRA_History/HRAHistory";
import { ReloadOutlined } from "@ant-design/icons";

export default class memberDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      TicketCreatedForProps: "",
      TicketCreatedForIDProps: "",
      Fromwhere: "Members",
      TicketShow: false,
      memberinfo: true,
      claimhistory: false,
      loader: false,
      loader3: true,
      activetab: this.props.fromPage === "Claims Search" ? 0 : 1,
      memberDetails: [],
      memberInfo: [],
      claimHistory: [],
      claimdata:{},
      Message: "",
      PCPHistory: [],
      pdfUrl: "",
      //  allPdf: [],
      filePath: null,
      isModalOpen: false,
      menuKey: 1,
      loader2: true,
      fetchedTotalRecords:0,

      authToken: "",
      userName: "",
      isEmptyDocModalOpen: false,
      isIDNotAvailable: false,

      // sideBarName: null,
      isHRAActive: false,
      hraHistory: [],
      isButtonVisible: false, // Initially hide the button
    };
  }
  TicketShowInfo = () => {
    this.setState((state) => ({ TicketShow: true }));
  };
  TicketHideInfo = () => {
    this.setState((state) => ({ TicketShow: false }));
  };
  getmemberShipInfo = (value) => {
    this.setState({
      memberinfo: true,
      activetab: value ? value : 0,
    });
  };

  getHraHistoryInfo = async (value) => {
    const tenantId = sessionStorage.getItem("Tanent");
    await this.getHRAHisotryData(tenantId, "", "");
    this.setState({ activetab: value ? value : 0 });
  };

  getPCPHistory = async () => {
    const uniqueMemberID =
      this.props.fromPage === "Claims Search"
        ? this.props.data.uniqueMemberID
        : this.props.data.UniqueMemberID;

    const headers = {
      Authorization: sessionStorage.getItem("access_token"),
    };

    let data = await fetch(
      Config.api +
        "/GetPCPHistoryForMember?uniqueMemberID=" +
        uniqueMemberID +
        "&PlanName=" +
        sessionStorage.getItem("planName"),
      { headers }
    );

    data = await data.json();
    if (data.Details && data.Details.length > 0) {
      this.setState({
        PCPHistory: data.Details,
      });
    }
  };

  getAuthToken = async () => {
    try {
      const response = await fetch(Config.Enrolment + "/GetAuthToken", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CustID: sessionStorage.getItem("planName") === "liberty" ? "101" : String(sessionStorage.getItem("Tanent")),
          PlanName: sessionStorage.getItem("planName"),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("inn", data.TokenInfo.token);
        localStorage.setItem("CNPtoken", data.TokenInfo.token);
        this.setState({ authToken: data.TokenInfo.token, userName:  data.TokenInfo.userDetails.userName, isButtonVisible: true}); // Assuming the response has a 'token' property
      } else {
        console.error("Failed to fetch authentication token");
      }
    } catch (error) {
      console.error("Error fetching authentication token:", error);
    }
  };

  getClaimsData = async () => {
    this.setState({ claimHistory: [] });
    let userNPI = sessionStorage.getItem("npivalue");
    let userTaxId = sessionStorage.getItem("taxid");
    let taxidNpiMapping = sessionStorage.getItem("taxidNpiMapping");
    let taxIDMapping = [];
    if (taxidNpiMapping) {
      for (let item of JSON.parse(taxidNpiMapping)) {
        taxIDMapping.push({
          billingProvider_Tax_ID: item.TaxID ? item.TaxID : "",
          npi: item.NPI,
        });
      }
    }
    let taxMapping = [];
    if (userNPI || userTaxId) {
      taxMapping = [
        {
          billingProvider_Tax_ID: userTaxId ? JSON.parse(userTaxId)[0].toString() : "",
          npi: userNPI ? [userNPI] : [],
        },
      ];
    }
    const SubscriberID =
      this.props.fromPage === "Claims Search"
        ? this.props.data.subscribeID
        : this.props.data.SubscriberID;

    let data = await fetch(Config.api + "/GetClaimDeatils", {
      method: "POST",
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        planName: sessionStorage.getItem("planName"),
        claimNumber: null,
        billingProviderFullName: null,
        taxidNPIs: taxIDMapping.length > 0 ? taxIDMapping : taxMapping,
        npi: null,
        billingProvider_Tax_ID: null,
        subscriber_ID: SubscriberID ? SubscriberID : null,
        memberFullName: null,
        providerFullName: null,
        dosFromDate: null,
        dosToDate: null,
        totalNetPaymentAmt: null,
        totalCharges: null,
        claimStatus: null,
        claimType: null,
      }),
    });
    data = await data.json();
    this.setState({ fetchedTotalRecords: data.TotalRecords });
    if (data.claimsDetails && data.claimsDetails.length > 0) {
      // Move billingNPI and renderingNPI after pcpNPI
      data.claimsDetails = data.claimsDetails.map(obj => {
        // Destructure out the fields to move
        const { renderingNPI, billingNPI, ...rest } = obj;

        const newObj = {};
        for (const key in rest) {
          newObj[key] = rest[key];

          // After inserting pcpNPI, insert the moved fields
          if (key === "pcpNPI") {
            newObj.renderingNPI = renderingNPI;
            newObj.billingNPI = billingNPI;

          }
        }
        return newObj;
      });
    }
    if (data.claimsDetails && data.claimsDetails.length > 0) {
      this.setState({
        claimHistory: data.claimsDetails,
        claimdata:data,
        loader: true,
      });
    }
  };

  launchHRA = () => {
    const url = Config.LaunchHraUrl;
    const hraQueryParams = {
      memberNumber: this.state.TicketCreatedForIDProps,
      firstName: this.state.memberDetails.FirstName,
      lastName: this.state.memberDetails.LastName,
      DOB: this.state.memberDetails.DateOfBirth,
      pcpID: this.state.memberDetails.CenterID,
      pcpName: this.state.memberDetails.PcpName,
      npi: this.state.PCPHistory?.[0]?.npi || null,
      taxId: this.state.PCPHistory?.[0]?.taxID || null   
    };
    const queryString = Object.keys(hraQueryParams)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(
            hraQueryParams[key]
          )}`
      )
      .join("&");
    const redirectUrl = `${url}?${queryString}`;
    window.open(redirectUrl, "_blank");
  };

  makeCall = () => {
    const queryParams = new URLSearchParams({
      // PlanName: "Advantage Care by Ultimate",
      PlanName: this.state.memberDetails.PlanName,
      PBPCode: this.state.memberDetails.PbpCode,
      County: this.state.memberDetails.County,
      TenantID: sessionStorage.getItem('Tanent')
    }).toString();

    // Make the API call to fetch the PDF data
    fetch(`${Config.api}/GetPlanBenefitsAttachmentsLink?${queryParams}`, {
      method: "GET",
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
      // Adjust any other request options if needed
    })
      .then((response) => response.json())
      .then((data) => {
        // Assuming the API response format is as described
        if (
          data &&
          data.PlanBenefitsAttachments &&
          data.PlanBenefitsAttachments.length > 0
        ) {
          // Here, we are opening the first PDF attachment in the modal popup
          // setPdfUrl(data.PlanBenefitsAttachments[0].FilePath);
          this.setState({
            //  allPdf: [data],
            filePath: data.PlanBenefitsAttachments[0].FilePath,
            //  sideBarName: data.PlanBenefitsAttachments[0].PlanAttachmentType,
            isModalOpen: true,
          });
          this.GetAttachment();
        } else {
          this.setState({
            isEmptyDocModalOpen: true,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching PDF data:", error);
      });
  };

  makeCall2 = () => {
    this.setState({loader2: true,  isModalOpen:true})
    
    console.log("authh",this.props.data.SubscriberID)
    const queryParams = new URLSearchParams({
      memberId: this.props.data.SubscriberID,
      CustID: sessionStorage.getItem("planName") === "liberty" ? "101" : String(sessionStorage.getItem("Tanent")),
      username: sessionStorage.getItem("userName"),
      planName: sessionStorage.getItem("planName")
    }).toString();
    // Make the API call to fetch the PDF data
    fetch(`${Config.Enrolment}/GetMemeberIdCard?${queryParams}`, {
      method: "GET",
      headers: {
        Authorization: this.state.authToken,
        Accept: "application/json",
        "Content-type": "application/json",
      },
      // Adjust any other request options if needed
    })
      //.then((response) => response.json())
      .then((response) => {
        console.log("Raw response:", response);
        console.log(response.status)
        if(response.status == 200){
          this.setState({ 
            isModalOpen:true,
             loader2: false });
        }else{
             this.setState({
              loader2: false,  
              isModalOpen:false,
              isEmptyDocModalOpen: true,
              isIDNotAvailable: true,
          })
        }
        return response.json();  // Parse response body as JSON
      })
      .then((data) => {
        console.log("data@",data)

        this.openModalWithPdf(data) 

        //  let base64ToBlob = (base64String, type = 'application/pdf') => {
        //   let binaryString = window.atob(base64String);  // Decode base64
        //   let len = binaryString.length;
        //   let bytes = new Uint8Array(len);
          
        //   for (let i = 0; i < len; i++) {
        //     bytes[i] = binaryString.charCodeAt(i);
        //   }
          
        //   return new Blob([bytes], { type });
        // };

        //  console.log(base64ToBlob)
        // Assuming the API response format is as described
        // if (
        //   data &&
        //   data.PlanBenefitsAttachments &&
        //   data.PlanBenefitsAttachments.length > 0
        // ) {
        //   // Here, we are opening the first PDF attachment in the modal popup
        //   // setPdfUrl(data.PlanBenefitsAttachments[0].FilePath);
        //   this.setState({
        //     //  allPdf: [data],
        //     filePath: data.PlanBenefitsAttachments[0].FilePath,
        //     //  sideBarName: data.PlanBenefitsAttachments[0].PlanAttachmentType,
        //     isModalOpen: true,
        //   });
        //   this.GetAttachment();
        // } else {
        //   this.setState({
        //     isEmptyDocModalOpen: true,
        //   });
        // }
      })
      .catch((error) => {
        console.error("Error fetching PDF data:", error);
      });
  };


  openModalWithPdf = (base64String) => {
    
    let blob = this.base64ToBlob(base64String);
    let url = URL.createObjectURL(blob);
    this.setState({ pdfUrl: url
      });

    //setPdfUrl(url);
    //setIsModalOpen(true);
  };

   base64ToBlob = (base64, type = 'application/pdf') => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
  
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type });
  };

  tempNonAdminCheck = () => {
    if (sessionStorage.getItem("PlanAdminRole") !== "Plan Admin") {
      if (
        !sessionStorage.getItem("taxidNpiMapping") &&
        !sessionStorage.getItem("taxid") &&
        !sessionStorage.getItem("npivalue")
      )
        return false;
    }
    return true;
  };

  GetAttachment = () => {
    const paramKey = this.state.filePath;
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/pdf",
        // "Content-Disposition": "attachment",
      },
      responseType: "arraybuffer",
    };
    axios
      .get(
        `${Config.api}/GetPlanBenefitsAttachment?Key=${paramKey}`,
        axiosConfig
      )
      .then((res) => {
        let blob = new Blob([res.data], { type: "application/pdf" });

        const fileURL = URL.createObjectURL(blob);
        this.setState({ pdfUrl: fileURL, loader2: false });
      })
      .catch((err) => {
        // console.log(err);
      });
  };
  handleModalViewClose = () => {
    this.setState({ isModalOpen: false, pdfUrl: "" });
  };

  getIsHRAActive = () => {
    const hraButtonEnabled = localStorage.getItem("IsHRAPopupActive");
    this.setState((state) => ({ isHRAActive: hraButtonEnabled }));
  };

  getHRAHisotryData = async (tenantId, createdDate, createdBy) => {
    const url = Config.api + "/GetHRADetailsForMember";
    const headers = {
      Authorization: sessionStorage.getItem("access_token"),
    };

    const payload = {
      MemberId: this.state.TicketCreatedForIDProps,
      TenantId: tenantId,
      CreatedDate: createdDate,
      PcPId: null,
      PcPName: null,
      MemberPlan: null,
    };

    const response = await axios.post(url, payload, { headers });
    const data = response.data;

    this.setState({
      hraHistory: data.HRADetails,
    });
  };

  componentDidMount() {
    const headers = { Authorization: sessionStorage.getItem("access_token") };
    // Api for member details card section. loading the responce in memberDetails array....
    const uniqueMemberID =
      this.props.fromPage === "Claims Search"
        ? this.props.data.uniqueMemberID
        : this.props.data.UniqueMemberID;
    const planCode =
      this.props.fromPage === "Claims Search"
        ? this.props.data.planCode
        : this.props.data.PlanCode;
    fetch(
      Config.api +
        "/GetMemberHeaderDetailsByUniqueID?uniqueMemberID=" +
        uniqueMemberID +
        "&planCode=" +
        planCode +
        "&PlanName=" +
        sessionStorage.getItem("planName"),
      { headers }
    )
      .then((res) => res.json())
      .then((res) => {
        localStorage.setItem("PbpCode", res.MemberHeader.PbpCode);
        localStorage.setItem("planname", res.MemberHeader.PlanName);

        this.setState({
          TicketCreatedForProps: res.MemberHeader.FirstName.concat(
            " ",
            res.MemberHeader.MiddleName
              ? res.MemberHeader.MiddleName
              : res.MemberHeader.LastName
          ).concat(
            " ",
            res.MemberHeader.MiddleName ? res.MemberHeader.LastName : ""
          ),
          //  TicketCreatedForIDProps: res.MemberHeader.MBI,
          memberDetails: res.MemberHeader,
          loader: true,
        });
      });

    // Api for member info tab. loading the responce in the member info array
    fetch(
      Config.api +
        "/GetMemberShipInfo?uniqueMemberID=" +
        uniqueMemberID +
        "&PlanName=" +
        sessionStorage.getItem("planName"),
      { headers }
    )
      .then((res) => res.json())
      .then((res) => {
        console.log("patel", res);
        this.setState({
          TicketCreatedForIDProps: res.MemberShipInfo[0]?.SubscriberID
            ? res.MemberShipInfo[0]?.SubscriberID
            : "",
          memberInfo: res.MemberShipInfo,
          loader: true,
        });

         // this.getAuthToken();
      });

    this.getClaimsData();

    this.getAuthToken();

    this.getPCPHistory();

    this.getIsHRAActive();
  }

  render() {
    const planName = sessionStorage.getItem("planName");
    const TicketHideInfo = () => {
      this.setState((state) => ({ TicketShow: false }));
    };
    const warning = () => {
      modal.confirm({
        title: "Are you sure to cancel",
        content: "cancel will discard all the added data",
        onOk() {
          TicketHideInfo();
        },
        okText: "Yes, Cancel",
        cancelText: "No",
      });
    };
    const CancelButton = () => (
      <space wrap>
        <button
          style={{
            display: "inline-block",
            align: "right",
            verticalAlign: "middle",
            marginTop: "-34px",
          }}
          className="details-tab p-1 pl-2 pr-2"
          onClick={warning}
        >
          Cancel
        </button>
      </space>
    );
    var today = new Date();
    // var dd = String(today.getDate()).padStart(2, "0");
    // var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    // var yyyy = today.getFullYear();
    // today = yyyy + "-" + mm + "-" + dd;
    // today = mm + "/" + dd + "/" + yyyy;
    // today = today.toString();

    return (
      <div>
        <div className="member-text">Member Details</div>

        <div className="button-container" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        {this.state.isButtonVisible && (
        <div className="complaint-button">
              <PrimaryButton
                style={{
                  display: "inline-block",
                  align: "right",
                  verticalAlign: "middle",
                  marginTop: "-34px",
                }}
                className={"details-tab p-1 pl-2 pr-2"}
                label={"Print ID Card"}
                onClick={this.makeCall2}
              />
            </div>
        )}

        {/* {sessionStorage.getItem("AdminRole") === "User Admin" &&
          sessionStorage.getItem("planName") === "ultimate" &&
          (sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
            sessionStorage.getItem("PlanAdminRole") === "Plan Admin") &&
          sessionStorage.getItem("EligibilityOnlyFlag") === "false" &&
          !this.state.TicketShow && (
            <div className="complaint-button">
              <PrimaryButton
                style={{
                  display: "inline-block",
                  align: "right",
                  verticalAlign: "middle",
                  marginTop: "-34px",
                }}
                className={"details-tab p-1 pl-2 pr-2"}
                label={"Create a Ticket"}
                onClick={() => this.TicketShowInfo()}
              />
            </div>
          )} */}

          </div>
        {this.state.loader === false ? (
          <div style={{ marginTop: "36vh", marginLeft: "46vw" }}>
            <Spin size="large" />
            <div
              style={{ marginLeft: "-6vw" }}
              className="search-sreen-text"
            ></div>
          </div>
        ) : (
          ""
        )}

        {this.state.memberDetails != "" && (
          <Card className="pr-2 mr-2 pb-2 details-header">
            <Row>
              <Col span={20}>
                <Row className="pb-2">
                  <Col
                    span={
                      sessionStorage.getItem("planName") === "ultimate"
                        ? 16
                        : 20
                    }
                    className="member-name p-2"
                  >
                    {this.state.memberDetails.FirstName +
                      " " +
                      (this.state.memberDetails.MiddleName == null
                        ? ""
                        : this.state.memberDetails.MiddleName + " ") +
                      this.state.memberDetails.LastName}{" "}
                    <span className="member-age">
                      ( {this.state.memberDetails.Gender},{" "}
                      {this.state.memberDetails.Age} )
                    </span>
                  </Col>
                  {sessionStorage.getItem("planName") === "ultimate" &&
                    this.state.activetab === 1 && (
                      <Col span={4} className="mt-1 mb-2">
                        <Col className="details-mbi text-size-header">
                          Rx Coverage Vendor{" "}
                          <div className="text-size-data">
                            {this.state.memberDetails.Drug_Coverage_Indicator
                              ? this.state.memberDetails
                                  .Drug_Coverage_Indicator === "Y"
                                ? this.state.memberDetails.Other_RX_Name
                                : sessionStorage.getItem("planName") ===
                                  "ultimate"
                                ? "Ultimate Health Plan"
                                : sessionStorage.getItem("planName")
                              : sessionStorage.getItem("planName") ===
                                "ultimate"
                              ? "Ultimate Health Plan"
                              : sessionStorage.getItem("planName")}
                          </div>
                        </Col>
                      </Col>
                    )}
                  <Col span={4} className="mt-1 mb-2">
                    <Col className="details-mbi text-size-header">
                      MBI{" "}
                      <div className="text-size-data">
                        {this.state.memberDetails.MBI}
                      </div>
                    </Col>
                  </Col>
                </Row>

                <div className="border-horizental ml-1"></div>

                <Row className="mt-3 ml-2">
                  <Col span={4} className="details-header-row">
                    Plan:{" "}
                    <div className="details-header-sub">
                      {this.state.memberDetails.PlanName}
                    </div>
                  </Col>
                  <Col span={4} className="details-header-row">
                    PCP Name:{" "}
                    <div className="details-header-sub">
                      {this.state.memberDetails.PcpName}
                    </div>
                  </Col>
                  <Col span={4} className="details-header-row">
                    PCP ID:{" "}
                    <div className="details-header-sub">
                      {this.state.memberDetails.CenterID}
                    </div>
                  </Col>
                  <Col span={4}>
                    {this.state.memberDetails.MoopYearPrevious ? (
                      <div className="details-header-row">
                        Total MOOP
                        {this.state.memberDetails.MoopYearPrevious}:
                      </div>
                    ) : (
                      <div className="details-header-row">Previous Moop</div>
                    )}

                    <div className="details-header-sub">
                      <span
                        style={{
                          color:
                            !this.state.memberDetails.MoopAmountPrevious &&
                            !this.state.memberDetails.MoopLimitPrevious
                              ? "grey"
                              : "",
                        }}
                        className=""
                      >
                        {" "}
                        $
                        {this.state.memberDetails.MoopAmountPrevious
                          ? parseFloat(
                              this.state.memberDetails.MoopAmountPrevious
                            ).toFixed(2)
                          : 0}{" "}
                        / $
                        {this.state.memberDetails.MoopLimitPrevious
                          ? parseFloat(
                              this.state.memberDetails.MoopLimitPrevious
                            ).toFixed(2)
                          : 0}
                      </span>
                    </div>
                  </Col>
                  <Col span={4}>
                    {this.state.memberDetails.MoopYearCurrent ? (
                      <div className="details-header-row">
                        Total MOOP
                        {this.state.memberDetails.MoopYearCurrent}:
                      </div>
                    ) : (
                      <div className="details-header-row">Current Moop</div>
                    )}
                    <div
                      className="details-header-sub"
                      style={{
                        color:
                          !this.state.memberDetails.MoopAmountCurrent &&
                          !this.state.memberDetails.MoopLimitCurernt
                            ? "grey"
                            : "",
                        marginLeft: "2px",
                      }}
                    >
                      $
                      {this.state.memberDetails.MoopAmountCurrent
                        ? parseFloat(
                            this.state.memberDetails.MoopAmountCurrent
                          ).toFixed(2)
                        : 0}{" "}
                      / $
                      {this.state.memberDetails.MoopLimitCurernt
                        ? parseFloat(
                            this.state.memberDetails.MoopLimitCurernt
                          ).toFixed(2)
                        : 0}
                    </div>
                  </Col>
                </Row>

                <Row className="mt-4 ml-2">
                  <Col span={4} className="details-header-row">
                    Contact:{" "}
                    <div className="details-header-sub">
                      {this.state.memberDetails.PhoneNumber}
                    </div>
                  </Col>
                  <Col span={4} className="details-header-row">
                    PCP Contact:{" "}
                    <div className="details-header-sub">
                      {this.state.memberDetails.PcpPhone}
                    </div>
                  </Col>
                  <Col span={4} className="details-header-row">
                    D.O.B:{" "}
                    <div className="details-header-sub">
                      {this.state.memberDetails.DateOfBirth}
                    </div>
                  </Col>
                  <Col span={4} className="details-header-row">
                    Email:{" "}
                    <div
                      className="details-header-sub"
                      style={{ marginLeft: "2px" }}
                    >
                      {"- - -"}
                    </div>
                  </Col>
                  <Col span={6} className="details-header-row">
                    Effective:
                    <Col
                      className={
                        // this.state.memberDetails.PlanTerminationDate >= today
                        today <=
                        new Date(this.state.memberDetails.PlanTerminationDate)
                          ? "cercle cercle-green mt-1"
                          : "cercle cercle-red mt-1"
                      }
                      span={1}
                      push={6}
                      style={{ marginLeft: "-9px" }}
                    ></Col>
                    <div className="details-header-sub">
                      {this.state.memberDetails.PlanEffectiveDate} -
                      {this.state.memberDetails.PlanTerminationDate}
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col span={4}>
                {/* <Row>
                  <Col span={24}></Col>
                </Row> */}
                <Row className="pl-1 pt-2">
                  <div className="border-vertical pl-2 pt-2">
                    <Col span={4} className="mb-2 member-details-address">
                      Address:
                    </Col>
                    <Col
                      span={20}
                      push={3}
                      // className="member-details-address-text mb-2 pt-1"
                      className="member-details-address-text mb-2"
                    >
                      {this.state.memberDetails.AddressLine1}
                      {/* 46-A Street, LincolnBlvd, Suite 046 */}
                    </Col>
                    <Col span={24} className="mb-2 member-details-address">
                      City:
                      <span className="member-details-address-text ml-4">
                        {" "}
                        {this.state.memberDetails.City}
                      </span>
                    </Col>
                    <Col span={24} className="mb-2 member-details-address">
                      State:
                      <span className="member-details-address-text ml-3">
                        {" "}
                        {this.state.memberDetails.State}
                      </span>
                    </Col>
                    <Col span={24} className="member-details-address">
                      Zipcode:
                      <span className="member-details-address-text">
                        {" "}
                        {this.state.memberDetails.ZipCode}
                      </span>
                    </Col>
                  </div>
                </Row>
              </Col>
            </Row>
          </Card>
        )}
        {this.state.TicketShow && (
          <div>
            <div className="ticket-header">Create Ticket</div>
          </div>
        )}

        {this.state.TicketShow && (
          <div>
            <CreateTicket
              TicketHideInfo={this.TicketHideInfo}
              Fromwhere={this.state.Fromwhere}
              TicketCreatedForProps={this.state.TicketCreatedForProps}
              TicketCreatedForIDProps={this.state.TicketCreatedForIDProps}
            />
          </div>
        )}

        {/* Calling membership Info component */}
        {(
          <div className="mt-4 pr-2">
            <div
              className="pb-2"
              style={{ width: "79%", display: "inline-block" }}
            >
              {this.props.fromPage === "Claims Search" ? (
                <Row
                  style={{ background: "#FFF", width: "100%" }}
                  className="details-body p-1"
                >
                  <Col span={4}>
                    <PrimaryButton
                      style={{ width: "9vw" }}
                      onClick={() => this.getmemberShipInfo(1)}
                      className={
                        this.state.activetab === 1
                          ? "details-tab p-1 pl-2 pr-2"
                          : "simple-button"
                      }
                      label={"Membership Info"}
                    />
                  </Col>
                  {sessionStorage.getItem("EligibilityOnlyFlag") === "true" ? (
                    this.tempNonAdminCheck() ? (
                      <Col span={4} className="ml-2">
                        <PrimaryButton
                          style={{ width: "9vw" }}
                          onClick={() => this.getmemberShipInfo(0)}
                          className={
                            this.state.activetab === 0
                              ? "details-tab p-1 pl-2 pr-2"
                              : "simple-button"
                          }
                          label={"Claims"}
                        />
                      </Col>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {sessionStorage.getItem("EligibilityOnlyFlag") === "true" ? (
                    <Col span={4}>
                      <PrimaryButton
                        style={{ width: "9vw" }}
                        onClick={() => this.getmemberShipInfo(3)}
                        className={
                          this.state.activetab === 3
                            ? "details-tab p-1 pl-2 pr-2"
                            : "simple-button"
                        }
                        label={"Authorization"}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                  {sessionStorage.getItem("EligibilityOnlyFlag") === "true" ? (
                    <Col span={4}>
                      {
                        (sessionStorage.getItem("planName") === "ultimate" || 
                        sessionStorage.getItem("planName") === "solis") && (
                        <PrimaryButton
                          style={{ width: "9vw" }}
                          onClick={() => this.getmemberShipInfo(2)}
                          className={
                            this.state.activetab === 2
                              ? "details-tab p-1 pl-2 pr-2"
                              : "simple-button"
                          }
                          label={"PCP History"}
                        />
                      )}
                    </Col>
                  ) : (
                    ""
                  )}
                  {this.state.isHRAActive === "true" ? (
                    <Col span={3}>
                      <PrimaryButton
                        style={{ width: "9vw" }}
                        onClick={() => this.getHraHistoryInfo(5)}
                        className={
                          this.state.activetab === 5
                            ? "details-tab p-1 pl-2 pr-2"
                            : "simple-button"
                        }
                        label={"HRA History"}
                      />
                      <ReloadOutlined
                        title="Click to refresh HRA History Data"
                        onClick={() => this.getHraHistoryInfo(5)}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              ) : (
                <Row
                  style={{ background: "#FFF", width: "90%" }}
                  className="details-body p-1"
                >
                  <Col span={4}>
                    <PrimaryButton
                      style={{ width: "9vw" }}
                      onClick={() => this.getmemberShipInfo(1)}
                      className={
                        this.state.activetab === 1
                          ? "details-tab p-1 pl-2 pr-2"
                          : "simple-button"
                      }
                      label={"Membership Info"}
                    />
                  </Col>
                  {sessionStorage.getItem("EligibilityOnlyFlag") === "false" ? (
                    this.tempNonAdminCheck() ? (
                      <Col span={4} className="ml-2">
                        <PrimaryButton
                          style={{ width: "9vw" }}
                          onClick={() => this.getmemberShipInfo(0)}
                          className={
                            this.state.activetab === 0
                              ? "details-tab p-1 pl-2 pr-2"
                              : "simple-button"
                          }
                          label={"Claims"}
                        />
                      </Col>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {sessionStorage.getItem("EligibilityOnlyFlag") === "false" &&
                  sessionStorage.getItem("planName") !== "PodAmerica" &&   
                  sessionStorage.getItem("planName") !== "chapters" &&
                  sessionStorage.getItem("planName") !== "solis" ? (
                    <Col span={4}>
                      {(sessionStorage.getItem("planName") == "ultimate" || sessionStorage.getItem("planName") == "secur" || sessionStorage.getItem("planName") == "sonder" || sessionStorage.getItem("planName") == "csh")  && (

                        <PrimaryButton
                          style={{ width: "9vw" }}
                          onClick={() => this.getmemberShipInfo(3)}
                          className={
                            this.state.activetab === 3
                              ? "details-tab p-1 pl-2 pr-2"
                              : "simple-button"
                          }
                          label={"Authorization"}
                        />
                      )}
                    </Col>
                  ) : (
                    ""
                  )}
                  {sessionStorage.getItem("EligibilityOnlyFlag") === "false" ? (
                    <Col span={4}>
                      {(sessionStorage.getItem("planName") === "ultimate" || sessionStorage.getItem("planName") === "csh" ||
                       sessionStorage.getItem("planName") === "secur" || 
                       sessionStorage.getItem("planName") === "solis") && (
                        <PrimaryButton
                          style={{ width: "9vw" }}
                          onClick={() => this.getmemberShipInfo(2)}
                          className={
                            this.state.activetab === 2
                              ? "details-tab p-1 pl-2 pr-2"
                              : "simple-button"
                          }
                          label={"PCP History"}
                        />
                      )}
                    </Col>
                  ) : (
                    ""
                  )}
                  {sessionStorage.getItem("EligibilityOnlyFlag") === "false" && (planName === "solis" || planName === "ultimate") ? (
                    <Col span={4}>
                      {(planName === "solis" || planName === "ultimate") && (
                        <PrimaryButton
                          style={{ width: "9vw" }}
                          onClick={() => this.getmemberShipInfo(4)}
                          className={
                            this.state.activetab === 4
                              ? "details-tab p-1 pl-2 pr-2"
                              : "simple-button"
                          }
                          label={"Attestation"}
                        />
                      )}
                    </Col>
                  ) : (
                    ""
                  )}

                  {this.state.isHRAActive === "true" ? (
                    <Col span={4}>
                      <PrimaryButton
                        style={{ width: "9vw" }}
                        onClick={() => this.getHraHistoryInfo(5)}
                        className={
                          this.state.activetab === 5
                            ? "details-tab p-1 pl-2 pr-2"
                            : "simple-button"
                        }
                        label={"HRA History"}
                      />
                      <ReloadOutlined
                        title="Click to refresh HRA History Data"
                        onClick={() => this.getHraHistoryInfo(5)}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              )}
            </div>
            {this.state.activetab !== 1 && (
              <div className="Outer-Div">
                <div className="Inner-Div">
                  {this.state.isHRAActive == "true" && 
                  this.state.memberDetails?.IsActive === true && (
                    <button
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                        marginTop: "-34px",
                        height: "27px",
                        padding: "8px 16px",
                        marginTop: "0",
                      }}
                      className="details-tab custom_anchor p-1 pl-2 pr-2 mr-1"
                      onClick={this.launchHRA}
                    >
                      {" "}
                      Launch HRA
                    </button>
                  )}
                </div>
              </div>
            )}
            {this.state.activetab === 1 && (
              <div className="Outer-Div">
                <div className="Inner-Div">
                  {this.state.isHRAActive == "true" && 
                  this.state.memberDetails?.IsActive === true &&(
                    <button
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                        marginLeft: "-59px",// Adjust this value as needed
                        marginTop: "-34px",
                        height: "27px",
                        padding: "12px 20px",
                        width: "auto"
                      }}
                      className="details-tab custom_anchor p-1 pl-2 pr-2 mr-1"
                      onClick={this.launchHRA}
                    >
                      {" "}
                      Launch HRA
                    </button>
                  )}
                  {(sessionStorage.getItem("planName") == "ultimate" || sessionStorage.getItem("planName") == "csh" || 
                    sessionStorage.getItem("planName") == "secur") &&
                    sessionStorage.getItem("planName") !== "PodAmerica" &&
                    sessionStorage.getItem("planName") !== "sonder" &&
                    sessionStorage.getItem("planName") !== "chapters" &&
                    sessionStorage.getItem("planName") !== "solis" && (
                      <button
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                          marginTop: "-34px",
                          height: "27px",
                          width: "120px",
                        }}
                        className="details-tab custom_anchor p-1 pl-2 pr-2 mr-1"
                        onClick={this.makeCall}
                      >
                        {" "}
                        Plan Benefits
                      </button>
                    )}
                  <ReactToPrint
                    trigger={() => (
                      <PrimaryButton
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                          marginTop: "-34px",
                          height: "27px",
                        }}
                        className="details-tab p-1 pl-2 pr-2"
                        label={"Print Eligibility"}
                      />
                    )}
                    content={() => this.componentRef}
                  />
                </div>
              </div>
            )}

            <div style={{ display: "none" }}>
              <PrintEligibility
                MemberInfo={this.state.memberDetails}
                PCPHistoryInfo={this.state.PCPHistory}
                ref={(el) => (this.componentRef = el)}
                memberID={
                  this.state.memberInfo.length > 0 &&
                  this.state.memberInfo[0].SubscriberID
                    ? this.state.memberInfo[0].SubscriberID
                    : ""
                }
              />
            </div>
            <div className="tab-details-card">
              {this.state.activetab === 1 ? (
                !this.state.loader ? (
                 <div style={{ marginTop: "10%", marginLeft: "90vh", marginBottom: "10%" }}>
                   Loading...
                 </div>
              ) : this.state.memberInfo.length > 0 ? (
                <Membershipinfo memberinfo={this.state.memberInfo} />
              ) : (
                <div
                  style={{
                    marginTop: "10%",
                    marginLeft: "90vh",
                    marginBottom: "10%",
                  }}
                >
                  No Record Found !
                </div>
                )
              ) : this.state.activetab === 2 &&
                this.state.PCPHistory.length > 0 ? (
                <PCPHistory PCPHistoryInfo={this.state.PCPHistory} />
              ) : this.state.activetab === 2 &&
                this.state.PCPHistory.length === 0 ? (
                <div
                  style={{
                    marginTop: "10%",
                    marginLeft: "90vh",
                    marginBottom: "10%",
                  }}
                >
                  No Record Found !
                </div>
              ) : this.state.activetab === 4 ? (
              <Attestation PCPHistoryInfo={this.state.PCPHistory} authToken={this.state.authToken} MBI={this.state.memberDetails.MBI} memberDetails={this.state.memberDetails} isButtonVisible={this.state.isButtonVisible}/>
              ) : this.state.activetab === 3 ? (
                <div
                  style={{
                    width: "97%",
                    marginTop: "10px",
                    padding: "0px",
                    marginLeft: "40px",
                  }}
                >
                  <NewTab
                    hereFrom="memberDetails"
                    activetab={this.state.activetab}
                    // tabName={this.props.tabName}
                    uniqueId={this.state.memberInfo.SubscriberID}
                    subId={this.props.data}
                    fromPage={this.props.fromPage}
                    user={this.props.data}
                    memberDetails={this.state.memberDetails}
                    member={this.state.member}
                    activeKey={this.props.activeKey}
                  />
                </div>
              ) : this.state.activetab === 5 ? (
                <HRAHistory
                  HRAHistoryInfo={this.state.hraHistory}
                  memberId={this.state.TicketCreatedForIDProps}
                ></HRAHistory>
              ) : this.state.claimHistory.length > 0 ? (
                <div className="pt-2 mt-1">
                  <ClaimsSearchDashboard
                    hereFrom="memberDetails"
                    claimsdata={this.state.claimdata}
                    fetchedTotalRecords={this.state.fetchedTotalRecords}
                    fromPage={this.props.fromPage}
                    memberid={
                      this.state.memberInfo &&
                      this.state.memberInfo[0] &&
                      this.state.memberInfo[0].SubscriberID
                        ? this.state.memberInfo[0].SubscriberID
                        : this.props.data?.SubscriberID
                    }
                  />
                </div>
              ) : (
                <div className="  h5 d-flex justify-content-center my-3">No Record Found !</div>
              )}
            </div>
          </div>
        )}
        {/* Calling membership Info component End*/}

        {this.state.isModalOpen && (
          // <div className="modal">
          //   <div className="modal-content">
          <Modal
            title={<div className="documentPreview">Document Preview</div>}
            open={this.state.isModalOpen}
            onCancel={this.handleModalViewClose}
            maskClosable={false}
            footer={null}
            destroyOnClose={true}
            centered={true}
            width={1500}
            style={{ marginTop: "5px" }}
          >
            {/* <span className="close" onClick={this.closeModal}>
              &times;
            </span>  */}
            <div className="availableDoc">
              {/* {this.state.allPdf[0].PlanBenefitsAttachments.length} */}
            </div>
            {this.state.pdfUrl && !this.state.loader2 ? (
              <div style={{ width: "100%", height: "85vh" }}>
                <iframe
                  src={this.state.pdfUrl}
                  height="100%"
                  width="100%"
                  style={{ border: "0" }}
                  position="relative"
                />
              </div>
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "85vh",
                  textAlign: "center",
                  paddingTop: "20%",
                }}
              >
                <Spin size="large" />
              </div>
            )}
          </Modal>
        )}
        {this.state.isEmptyDocModalOpen && (
          // <div className="modal">
          //   <div className="modal-content">
          <Modal
            title={<div className="documentPreview">Document Preview</div>}
            open={this.state.isEmptyDocModalOpen}
            onCancel={() => {
              this.setState({
                isEmptyDocModalOpen: false,
              });
            }}
            maskClosable={false}
            footer={null}
            destroyOnClose={true}
            centered={true}
            width={600}
            style={{ marginTop: "5px" }}
          >
            <Typography
              style={{
                fontSize: "18px",
              }}
            >
           {this.state.isIDNotAvailable
              ? "No Image Available."
              : "No document for this combination."}
            </Typography>
          </Modal>
        )}
      </div>
    );
  }
}
